import { predicateEffect } from 'store/listenerMiddleware';
import { AnyAction } from 'store/store';
import State from 'store/State';
import { EstimatedTradeCostComponentState } from 'widgets/estimatedTradeCost/widget/store/componentSlice';
import { selectPortfolioSelection } from 'portfolio/store/selectors';
import { buildLogger } from '@instinet-analytics/core-lib';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { ComponentSliceActions } from 'widgets/store/component/componentSlice';

export const buildClearComponentStateOnSelectedOrderChangedEffect = (
    prefix: string,
    selectWidgetsState: (state: State) => { [widgetId: string]: unknown },
    selectComponentState: (
        state: State,
        key: string
    ) => EstimatedTradeCostComponentState,
    createUpdateComponentAction: ComponentSliceActions<EstimatedTradeCostComponentState>['createUpdateComponentAction']
) =>
    predicateEffect(
        (action: AnyAction, currentState: State, previousState: State) => {
            const currentValue = new PortfolioSelectionWrapper(
                selectPortfolioSelection(currentState)
            );
            const previousValue = new PortfolioSelectionWrapper(
                selectPortfolioSelection(previousState)
            );
            return (
                currentValue.selectedOrder?.orderID !==
                previousValue.selectedOrder?.orderID
            );
        },
        async (action, api) => {
            const {
                getState,
                extra: { loggingService },
                dispatch,
            } = api;

            const state = getState();

            const instances = selectWidgetsState(state);

            const logger = buildLogger(
                `${prefix}-clearComponentStateOnSelectedOrderChangedEffect`,
                loggingService
            );

            for (const key of Object.keys(instances)) {
                const currentQty = selectComponentState(state, key);
                if (currentQty) {
                    logger.debug(`Clearing component state qty for ${key}`);
                    dispatch(
                        createUpdateComponentAction(key, {
                            qty: undefined,
                        })
                    );
                }
            }
        }
    );
